document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-card-carousel');

  carousels.forEach(carousel => {
    const mainImage = carousel.querySelector('.carousel-main-img');
    const thumbnails = Array.from(carousel.querySelectorAll('.carousel-thumbnail'));
    const prevBtn = carousel.querySelector('.carousel-arrow-left');
    const nextBtn = carousel.querySelector('.carousel-arrow-right');

    if (!mainImage || thumbnails.length === 0) return;

    let currentIndex = thumbnails.findIndex(t => t.classList.contains('active'));
    if (currentIndex === -1) currentIndex = 0;

    function setImage(index) {
      const thumb = thumbnails[index];
      const fullSrc = thumb.getAttribute('data-full-src') || thumb.src;

      mainImage.src = fullSrc;
      mainImage.srcset = ''; // optional: keep simple

      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      currentIndex = index;
    }

    // Thumbnail clicks
    thumbnails.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => setImage(idx));
    });

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const newIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
        setImage(newIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const newIndex = (currentIndex + 1) % thumbnails.length;
        setImage(newIndex);
      });
    }
  });
});
